import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TermsUseImplRepository } from './terms-use-imp.respository';
import { TermsUseRepository } from '@/core/domain/terms-use/repositories/rental-policy.respository';
import { GetTermsUseUseCase } from '@/core/domain/terms-use/usecases/getTermsUse.usecase';

const getTermsUseUseCaseFactory = (repository: TermsUseRepository) =>
    new GetTermsUseUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetTermsUseUseCase,
            useFactory: getTermsUseUseCaseFactory,
            deps: [TermsUseImplRepository],
        },
        {
            provide: TermsUseRepository,
            useClass: TermsUseImplRepository,
        },
    ],
})
export class TermsUseDataModule {}
